import React, { useState } from 'react';
import styles from "./index.less";

const ImageLoading: React.FC = () => (
    <div className={styles.spinnerMark}>
        <div className={styles.spinner}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
);

interface ImageLoaderProps {
    src: string;
    alt?: string;
    className?: string;
    width?: string | number;
    height?: string | number;
    onLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
    onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
    style?: React.CSSProperties;
}

const ImageLoader: React.FC<ImageLoaderProps> = (props) => {
    const { src, alt, className, width, height, onLoad, style } = props;
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const handleImageLoaded = (e: React.SyntheticEvent<HTMLImageElement, Event>): void => {
        if (onLoad) onLoad(e);
        setTimeout(() => setIsLoading(false), 100);
    };



    return (
        <div
            className={`${styles.imageContainer} ${className || ''}`}
            style={{
                width,
                height,
                ...style
            }}
        >
            {isLoading && <ImageLoading />}

            <img
                src={src}
                alt={alt || '图片'}
                className={`${styles.image} ${isLoading ? styles.hidden : ''}`}
                onLoad={handleImageLoaded}
            />
        </div>
    );
};

export default ImageLoader;